import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import VerifyEmail from "@/pages/VerifyEmail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Pricing from "@/pages/Pricing";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import AuthCallback from "@/pages/AuthCallback";
import OnboardingRouter from "@/pages/onboarding/OnboardingRouter";
import Recommendations from "@/pages/Recommendations";
import Step1GoogleAds from "@/pages/onboarding/Step1GoogleAds";
import Step2Business from "@/pages/onboarding/Step2Business";
import Step3Strategy from "@/pages/onboarding/Step3Strategy";
import Dashboard from "@/pages/Dashboard";
import Strategy from "@/pages/Strategy";
import Reports from "@/pages/Reports";
import Notifications from "@/pages/Notifications";
import Settings from "@/pages/Settings";
import NotFound from "@/pages/NotFound";
import LegalPage from "@/legal/LegalPage";
import CookieNotice from "@/components/CookieNotice";

function AppRouter() {
    const location = useLocation();
    // CRITICAL: synchronous check for OAuth callback before normal routing
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            {/* Public legal pages — no auth required */}
            <Route path="/regulamin" element={<LegalPage slug="regulamin" />} />
            <Route path="/terms" element={<LegalPage slug="regulamin" />} />
            <Route path="/privacy" element={<LegalPage slug="privacy" />} />
            <Route path="/cookies" element={<LegalPage slug="cookies" />} />
            <Route path="/subprocessors" element={<LegalPage slug="subprocessors" multilingual={false} />} />
            <Route path="/pricing" element={<ProtectedRoute><Pricing /></ProtectedRoute>} />
            <Route path="/checkout/success" element={<ProtectedRoute><CheckoutSuccess /></ProtectedRoute>} />
            <Route path="/onboarding" element={<ProtectedRoute require="in-onboarding"><OnboardingRouter /></ProtectedRoute>} />
            <Route path="/onboarding/step-1" element={<ProtectedRoute require="in-onboarding"><Step1GoogleAds /></ProtectedRoute>} />
            <Route path="/onboarding/step-2" element={<ProtectedRoute><Step2Business /></ProtectedRoute>} />
            <Route path="/onboarding/step-3" element={<ProtectedRoute require="in-onboarding"><Step3Strategy /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/strategy" element={<ProtectedRoute require="onboarded"><Strategy /></ProtectedRoute>} />
            <Route path="/recommendations" element={<ProtectedRoute require="onboarded"><Recommendations /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute require="onboarded"><Reports /></ProtectedRoute>} />
            <Route path="/reports/:reportId" element={<ProtectedRoute require="onboarded"><Reports /></ProtectedRoute>} />
            <Route path="/notifications" element={<ProtectedRoute require="onboarded"><Notifications /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <AppRouter />
                    <CookieNotice />
                </BrowserRouter>
                <Toaster
                    theme="dark"
                    position="top-right"
                    richColors
                    toastOptions={{
                        style: { background: "#12121A", color: "#fff", border: "1px solid #2a2a36" },
                    }}
                />
            </AuthProvider>
        </div>
    );
}

export default App;